import { Grid, Typography, FormControlLabel, Checkbox } from '@mui/material';
import GenericInput from '../../AddLocation/Components/UI/GenericInput';
import Styles from '../Styles/SearchCustodiansStyles';
import { genericTitle } from '../../../assets/styles/appStyles';
import { useEffect, useRef, useState } from 'react';
import { debounceDelay } from '../../../settings/appConfig';
export default function ResearchCustodiansFilters({
  onSearchChanged,
  isFilterCleared,
  onSmartSearchToggle,
  isSmartSearchEnabled,
}: Readonly<{
  onSearchChanged: (name: string, phoneNumber: string) => void;
  isFilterCleared: boolean;
  onSmartSearchToggle: (isSmartSearchEnabled: boolean) => void;
  isSmartSearchEnabled: boolean;
}>) {
  useEffect(() => {
    if (isFilterCleared) {
      setSearchName('');
      setPhoneNumber('');

    }
  }, [isFilterCleared]);
  const [searchName, setSearchName] = useState<string>('');
  const [phoneNumber, setPhoneNumber] = useState<string>('');
  const searchNameTimeoutId = useRef<any>(null);
  const handleChangeName = (value: string) => {
    setSearchName(value);
    //apply debouncing
    if (searchNameTimeoutId.current) {
      clearTimeout(searchNameTimeoutId.current);
    }
    searchNameTimeoutId.current = setTimeout(() => {
      onSearchChanged(value, phoneNumber);
    }, debounceDelay);
  };
  
  const toggleSmartSearchInput = () => {
    const newState = !isSmartSearchEnabled; // Toggle based on current parent's state
    onSmartSearchToggle(newState); // Notify the parent component of the state change
  }
  return (
    <Grid container mt={2} sx={Styles.greyCard}>
      <Grid
        px={2}
        container
        justifyContent={'space-between'}
        alignItems="center"
      >
        {isSmartSearchEnabled ?
        <Typography align="left" sx={genericTitle}>
          Custodians Smart Search 
        </Typography>  
        : <Typography align="left" sx={genericTitle}>
           Search Custodians
        </Typography>}
      </Grid>
       <Grid
       px={2}
       mb={2}
       container
       alignItems="center"
     >
      <Grid item xs={12} md={6} lg={5}>
          <GenericInput
            name={`name`}
            label="Name"
            maxLength={120}
            placeholder=""
            value={searchName}
            onChange={(e: any) => {
              handleChangeName(e.target.value);
            }}
            errorMsg=""
            hasError={false}
            onBlur={() => {}}
          />
        </Grid>
        <Grid item sx={{ pl: 2 }}>
          <FormControlLabel
            control={
              <Checkbox
                checked={isSmartSearchEnabled}
                onChange={toggleSmartSearchInput}
                name="smartSearchToggle"
                color="primary"
              />
            }
            label="Search Custodian Name in Warnings"
          />
        </Grid>
       </Grid>
    </Grid>
  );
}
